const recipeModal = document.querySelector('#recipe-modal');
const recipesGrid = document.querySelector('.recipes__grid');
const recipeBtns = document.querySelectorAll('.recipes__modal-launcher');

if (recipeBtns.length > 0) {
    recipesGrid.addEventListener('click', (e) => recipeModalOpen(e));
}

const recipeModalOpen = (e) => {
    // finds the closest recipe item (which serves as the modal launcher as well)
    const recipeItem = e.target.closest('.recipes__item');
  
    if (!recipeItem) {
      return;
    }
    // the data will just be the <script> tag child of the recipeItem
    const data = JSON.parse(recipeItem.querySelector('script').innerHTML);
    
    // destructured data from the JSON
    const { name, description, image, recipeIngredient, recipeInstructions } = data;
    const desktopUrl = image[0].url;
    const desktopAlt = image[0].caption;
    const mobileUrl = image[1].url;
    const mobileAlt = image[1].caption;
    
    // begin replacing content in modal
    const recipeTitle = recipeModal.querySelector('.recipes__modal-title');
    const recipeName = recipeModal.querySelector('.full-recipe__name');
    recipeTitle.innerHTML = name;
    recipeName.innerHTML = name;
    const recipeDescription = recipeModal.querySelector('.full-recipe__intro-text');
    recipeDescription.innerHTML = description;
    const recipeImageDesktop = recipeModal.querySelector('.full-recipe__image--desktop');
    recipeImageDesktop.src = desktopUrl;
    recipeImageDesktop.alt = desktopAlt;
    const recipeImageMobile = recipeModal.querySelector('.full-recipe__image--mobile');
    recipeImageMobile.src = mobileUrl;
    recipeImageMobile.alt = mobileAlt;
    const recipeIngredientsContainer = recipeModal.querySelector('.full-recipe__ingredients');
    let ingredients = '';
    recipeIngredient.forEach((item) => {
      ingredients += item  + '<br />';
    });
    recipeIngredientsContainer.innerHTML = ingredients;
    const recipeDirectionsContainer = recipeModal.querySelector('.full-recipe__directions');
    let directions = '';
    recipeInstructions.forEach((item) => {
      directions += item.text  + '<br />';
    });
    recipeDirectionsContainer.innerHTML = directions;
};
